export const SOCIAL_MEDIA_LINKS = {
    'boon-facebook': 'https://www.facebook.com/booninterior',
    'boon-instagram': 'https://www.instagram.com/booninterior',
    'boon-email-hello': 'hello@booninterior.com',
    'boon-email-info': 'info@booninterior.com',
};
